export const DriverLicenseStateFieldData = {
  formControlName: 'driverLicenseState',
  id: 'grit-driver-license-state',
  label: 'Issuing state',
  requiredMessage: 'Your issuing state is required to process the application.',
};
